import Button from 'components/Button'
import LeftArrow from 'components/icons/LeftArrow'
import RoutePath from 'components/RoutePath'
import React, { useLayoutEffect, useState } from 'react'
import { EmptyDivElement } from '../../../../components/UIComponents/CommonStyledComponent'
import {
  Container,
  LeftSection,
  RightSection,
  SectionName,
  TopHeading,
} from '../Header/style'
import {
  autoJDFillStepNum,
  eligibilityCriteriaStepNum,
  previewStepNum,
} from '../RolesForm/Partials/EligibiltyCriteria/CommonFunctions'

const Header = ({
  currentStep,
  setCurrentStep,
  headingText,
  isCompanyContext,
  handleAddNewCompany,
  handleSubmitChange,
  setSave,
  handleDraftChange,
  handleTableNavigation,
  setTriggerBack,
  status = 0,
  publishButtonDisable,
  confirmLoading,
  setDraft,
  params,
  jdFile,
  handleNextChange,
  buttonLoading,
  setSkillSearch,
}) => {
  const [isDisabled, setIsDisabled] = useState(false)
  const handleBackChange = () => {
    setSkillSearch('')
    setSave(false)
    setDraft(false)
    setTriggerBack(true)
    if (currentStep >= previewStepNum) {
      setCurrentStep(eligibilityCriteriaStepNum)
    } else {
      setCurrentStep(currentStep - 1)
    }
  }
  useLayoutEffect(() => {
    const shouldDisable =
      (currentStep >= previewStepNum && publishButtonDisable) ||
      (currentStep === autoJDFillStepNum && !jdFile?.length) ||
      confirmLoading ||
      buttonLoading

    setIsDisabled(shouldDisable)
  }, [
    currentStep,
    previewStepNum,
    publishButtonDisable,
    autoJDFillStepNum,
    jdFile,
    confirmLoading,
    buttonLoading,
  ])
  return (
    <Container spaceBetween>
      <LeftSection centerVertically>
        <EmptyDivElement
          style={{ cursor: 'pointer' }}
          onClick={() =>
            isCompanyContext
              ? handleAddNewCompany(false)
              : handleTableNavigation()
          }
        >
          <LeftArrow />
        </EmptyDivElement>

        <SectionName column>
          <RoutePath from="JobRoles" path="/jobRoles" />
          <TopHeading> {headingText}</TopHeading>
        </SectionName>
      </LeftSection>
      <RightSection>
        {isCompanyContext ? (
          <Button.Primary
            text="Submit"
            onClick={() => handleSubmitChange(false)}
            disabled={confirmLoading}
          />
        ) : (
          <>
            {!status &&
              (currentStep != autoJDFillStepNum || params?.roleId) && (
                <Button.Secondary
                  text="Save as draft"
                  onClick={handleDraftChange}
                  disabled={confirmLoading}
                />
              )}
            {currentStep !== autoJDFillStepNum && (
              <Button.Primary
                text="Back"
                onClick={handleBackChange}
                disabled={confirmLoading}
              />
            )}
            <Button.Primary
              text={currentStep >= previewStepNum ? 'Publish' : 'Next'}
              onClick={handleNextChange}
              disabled={isDisabled}
            />
          </>
        )}
      </RightSection>
    </Container>
  )
}

export default Header
